var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.draggable)?_c('tr',{class:_vm.rowClasses(_vm.row._index),attrs:{"draggable":_vm.draggable},on:{"dragstart":function($event){return _vm.onDrag($event, _vm.row._index)},"drop":function($event){return _vm.onDrop($event, _vm.row._index)},"dragover":function($event){return _vm.allowDrop($event)}}},[_vm._t("default")],2):_c('tr',{class:_vm.rowClasses(_vm.row._index),attrs:{"draggable":false}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/table/table-tr.vue